//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class PracticeLogInputItem extends ItemBase {
    Date: string = "1970-01-01T00:00:00";
    Duration: number = 0;
    Note: string | null = null;
    StudentID: string | null = null;
    AssignmentName: string | null = null;
    TeacherID: string | null = null;

    constructor(initializer?: Partial<PracticeLogInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PracticeLogInputItem";
}
